module.exports = __webpack_public_path__ + "static/img/1.bf1f40f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/1.png
// module id = armE
// module chunks = 0